import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 30,
  medium: 22,
  small: 16,
  xSmall: 12
};
const ArrowDownBoldIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 16 16",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        stroke: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.3703 5L13 5.49483L8 11L3 5.49483L3.60175 5L8 9.76294L12.3703 5Z",
        stroke: "currentColor"
      }
    )
  );
};
ArrowDownBoldIcon.iconName = "ArrowDownBoldIcon";

export { ArrowDownBoldIcon };
